/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolExperimentIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-experiment"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M4.85 21.8Q3.17 21.8 2.46 20.3Q1.75 18.8 2.8 17.5L8.35 10.8L8.35 4.9L7.55 4.9Q7 4.9 6.63 4.5Q6.25 4.1 6.25 3.55Q6.25 3 6.63 2.6Q7 2.2 7.55 2.2L16.45 2.2Q17.02 2.2 17.44 2.59Q17.85 2.98 17.85 3.55Q17.85 4.13 17.44 4.51Q17.02 4.9 16.45 4.9L15.7 4.9L15.7 10.8L21.2 17.5Q22.25 18.8 21.52 20.3Q20.8 21.8 19.15 21.8ZM7.7 17.85L16.35 17.85L13.25 14.05L10.8 14.05Z" fill={color} />
    </svg>
  );
}
